import { render, staticRenderFns } from "./InputVuelidate.vue?vue&type=template&id=60e2e238&"
import script from "./InputVuelidate.vue?vue&type=script&lang=js&"
export * from "./InputVuelidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports